import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import React, { useLayoutEffect, useRef } from "react";
import styled from "styled-components";
import Accordion from "../Accordion";
import {linear_gradient3} from "../../styles/styles";
const Section = styled.section`
  min-height: 100vh;
  height: auto;
  width: 100vw;
  background-color: ${(props) => props.theme.text};
  position: relative;
  color: ${(props) => props.theme.body};
  margin-top: -35px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const Title = styled.h1`
  font-size: ${(props) => props.theme.fontxxl};
  text-transformation: uppercase;
  color: ${(props) => props.theme.body};

  margin: 1rem auto;
  border-bottom: 2px solid ${(props) => props.theme.cauroselColor};
  width: fit-content;

  @media (max-width: 48em) {
    font-size: ${(props) => props.theme.fontxl};
  }
`;

const Container = styled.div`
  width: 75%;
  margin: 2rem auto;

  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 64em) {
    width: 80%;
  }

  @media (max-width: 48em) {
    width: 90%;
    flex-direction: column;
  }

  & > *::last-child {
    & > *::first-child {
      margin-top: 0;
    }
  }
`;

const Box = styled.div`
  width: 45%;

  @media (max-width: 64em) {
    width: 90%;
    align-self: center;
  }
`;

const Faq = () => {
  const ref = useRef(null);
  gsap.registerPlugin(ScrollTrigger);
  useLayoutEffect(() => {
    let element = ref.current;

    ScrollTrigger.create({
      trigger: element,
      start: "top top",
      end: "bottom top",
      pin: true,
      pinSpacing: false,
      scrub: true,
      // markers: true,
    });

    return () => {
      ScrollTrigger.kill();
    };
  }, []);

  return (
    <Section ref={ref} id="faq" style={linear_gradient3}>
      <Title>FAQ</Title>
      <Container>
        <Box>
          <Accordion title="What are the marketing challenges faced by businesses?">
          Businesses encounter difficulties in marketing themselves effectively to drive foot traffic, particularly traditional businesses, due to factors such as high costs and time-consuming methods.
          </Accordion>
          <Accordion title="What opportunity does CryptoRunner offer?">
          CryptoRunner presents a next-generation geo-tagged playground, utilizing map-based gameplay to engage players and provide market visibility to communities and businesses.
          </Accordion>
          <Accordion title="Who is the target audience for CryptoRunner">
          The primary audience includes crypto projects, firms, and communities interested in minting NFTs tied to physical locations for marketing and engagement purposes. The secondary audience comprises retail businesses seeking to utilize NFT vouchers as marketing tools to drive foot traffic.
          </Accordion>
        </Box>
        <Box>
          <Accordion title="How does CryptoRunner guarantee foot traffic and high conversion rates for businesses?">
          By issuing NFT vouchers redeemable at physical locations, CryptoRunner ensures that consumers visit stores, thereby increasing the likelihood of conversions.
          </Accordion>
          <Accordion title="What advantages does CryptoRunner offer over traditional marketing methods">
          CryptoRunner promotes businesses for free through its browse function, charges only for successful conversions, and provides time-efficient access to a pool of potential consumers ready to collect NFTs
          </Accordion>
          <Accordion title="How can artists benefit from using CryptoRunner?">
          Artists can tokenize both physical and digital artworks on CryptoRunner, expanding their reach and potential sales.
          </Accordion>
        </Box>
      </Container>
    </Section>
  );
};

export default Faq;
